import { render, staticRenderFns } from "./LinkAccount.vue?vue&type=template&id=73d69f1c&scoped=true"
import script from "./LinkAccount.vue?vue&type=script&lang=js"
export * from "./LinkAccount.vue?vue&type=script&lang=js"
import style0 from "./LinkAccount.vue?vue&type=style&index=0&id=73d69f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d69f1c",
  null
  
)

export default component.exports